module.exports = __webpack_public_path__ + "static/media/banner_ssr_ticket_122f7174841ddf4c3bbf0441ff0e8cbd1.webp";